import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import $ from 'jquery'
import BaiduMap from 'vue-baidu-map'
import axios from 'axios'
import 'jquery'

// 导入全局样式
import './assets/css/common.css'
import VDistpicker from 'v-distpicker'
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper/dist/ssr'
import "../node_modules/swiper/dist/css/swiper.min.css";
import "../node_modules/swiper/dist/js/swiper.min";


Vue.component('v-distpicker', VDistpicker)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;

// 配置请求的根路径 '/api/'正式环境 打包记得改
axios.defaults.baseURL = '/api/'
    // axios.defaults.baseURL = 'http://192.168.7.125:6666/'
    // axios.defaults.baseURL = 'http://192.168.7.55:8090/'
Vue.use(BaiduMap, {
        // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key /
        ak: 'QrKw6BpO274b6mXQ5T1uSrMt2kZGLE5E'
    })
    // let baseURL = "/";
    // if (process.env.NODE_ENV === 'production') {
    //     baseURL = 'http://localhost:8080/';
    // }
    // const prefix = process.env.NODE_ENV === 'development' ? '/api' : '/api'
Vue.use(VueAwesomeSwiper)
    // Vue.use(vuePicturePreview)
new Vue({
    axios,
    router,
    store,
    data() {
        return {
            ImgUrl: axios.defaults.baseURL,
            // ImgUrl: 'http://192.168.7.125:8090/',

        }
    },
    render: h => h(App)
}).$mount('#app')

;